import React from 'react';
import ReactDOM from 'react-dom/client';

import './styles/index.css';

import { createTheme, ThemeProvider } from '@mui/material/styles';
import { frFR } from '@mui/material/locale';

import { AuthProvider } from "./utils/auth";

// google  
// désactivé pour l'instant
//import { GoogleOAuthProvider } from '@react-oauth/google';

import App from './components/App';

import * as swRegister from './sw-register';

const root = ReactDOM.createRoot(document.getElementById('root'));

const themeWithLocale = createTheme({}, frFR);

root.render(
// google  
// <GoogleOAuthProvider clientId="1003046480605-3scl8094q81pmtl14ldbi3n1rmjd561u.apps.googleusercontent.com">  
  <ThemeProvider theme={themeWithLocale}>
    <AuthProvider>
      <App />    
    </AuthProvider>    
  </ThemeProvider>      
// google      
// </GoogleOAuthProvider>    

);

swRegister.register();